

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface ProductModelMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface ProductModelMst {
    id?:number;
    name:any;
    catalogDescription:any;  
   
    instructions:any   ;
 
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
    updatedDate:Date;

    tenantId:any;
    branchId:any;
      
    parameters?: ProductModelMstParameter[];
    links?: any;
}

export abstract class ProductModelMstData { 
    abstract list(url: string): Observable<ProductModelMst[]>;
    abstract create(url: string,data: ProductModelMst): Observable<any>;
    abstract update(url: string,data: ProductModelMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
